import { Button } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import axios from '../utils/axios';

export default function TicketByQR({ showPopup, inProgress, setInProgress }) {
    const openQRScanner = () => {
        window.Telegram.WebApp.showScanQrPopup({
            text: '',
        }, (value) => {
            if (!value || inProgress) {
                return;
            }
            
            const proceed = () => {
                setInProgress(true);
                axios.post(`/api/ticket/${value}`, {
                    user: window.Telegram.WebApp.initDataUnsafe.user,
                    initData: window.Telegram.WebApp.initData,
                })
                    .then((payload) => {
                        const data = payload.data;
                        showPopup(data);
                    })
                    .catch(() => {
                        setInProgress(false);
                    });
            };

            proceed();
        });
    };

    return (
        <Button
            variant="contained"
            color="warning"
            startIcon={<QrCode2Icon />}
            onClick={openQRScanner}
        >
            Сканувати
        </Button>
    );
}
